class AdPreview {

    constructor($rootScope, CreativeService, $compile, $timeout) {
        
        this.$rootScope = $rootScope;
        this.CreativeService = CreativeService;
        this.$compile = $compile;
        this.$timeout = $timeout;

        this.sidebarMarkup = '  <sidebar ng-hide="isHidden" style="left: auto; top: 78px;" class="builder-sidebar">'

        return {
            restrict: 'E',
            scope: {
                'adunit': '@?',
                'campaignId': "@",
                'campaign': "=?"
            },
            templateUrl: 'builder/ad-preview.html',
            link: ($scope, $el) => {

                $scope.timeout = null;
                $scope.weatherPreview = { };

                $scope.hasWeatherLayer = function() {
                    var adunit = $scope.adunit;
                    if (!adunit || !adunit.canvases || !adunit.assets) return false;
                    return adunit.canvases.some(function(canvas) {
                        return (canvas.layers || []).some(function(layer) {
                            var asset = adunit.assets[layer.assetId];
                            return asset && asset.contentType === 'x-reflow-widget/weather';
                        });
                    });
                };

                if(!$scope.isCollapsed) {
                    if(!!localStorage.getItem("builderPreview.isCollapsed")) {
                        $scope.isCollapsed = localStorage.getItem("builderPreview.isCollapsed") == "true";
                    }
                    else {
                        $scope.isCollapsed = false;
                    }
                }

                $rootScope.$on("ad-preview", (ev, adunit) => {
                    $scope.adunit = adunit;
                    this.showCreative($scope, $el);
                });

                $scope.close = () => {
                    $el.css("top", "1000vh");
                    $(".ad-preview-container", $el).empty();
                    $("#reflow-skin-top").remove();
                    $("#reflow-skin-bottom").remove();
                    $("body").css({"margin-top": "initial", "margin-bottom": "initial"});
                };

                $scope.$watch('campaign', (newVal, oldVal) => {
                    if(!!newVal && !!oldVal) {
                        if(!$scope.timeout) {
                            $scope.timeout = this.$timeout(() => {
                                this.showCreative($scope, $el);
                                $scope.timeout = null;
                            }, 1500);
                        }
                    }
                }, true);

                $scope.$watch('weatherPreview', (newVal, oldVal) => {
                    if(!!newVal && !!oldVal && !!$scope.adunit) {
                        if(!$scope.timeout) {
                            $scope.timeout = this.$timeout(() => {
                                this.showCreative($scope, $el);
                                $scope.timeout = null;
                            }, 1500);
                        }
                    }
                }, true);

                $scope.$watch('isCollapsed', (newVal, oldVal) => {
                    if(typeof undefined != oldVal && (newVal != oldVal)) {
                        localStorage.setItem("builderPreview.isCollapsed", newVal);
                    }
                });
            }
        };
    }

    showCreative($scope, $el) {

        $(".ad-preview-container", $el).empty();

        let root = $scope.adunit.canvases.find( (x) => x.id == $scope.adunit.deviceroots.desktop );
        let width = root.width;
        let height = root.height;

        let tempAdunit = $scope.adunit;
        if(!!$scope.campaign) {
            if(!!$scope.campaign.macros) {
                tempAdunit.macros = $scope.campaign.macros;
            }
            if(!!$scope.campaign.dimensions) {
                tempAdunit.dimensions = $scope.campaign.dimensions;
            }
        }
        if ($scope.weatherPreview) {
            tempAdunit.weatherPreview = $scope.weatherPreview;
        }

        this.CreativeService.previewAdunit(tempAdunit, $scope.campaignId)
            .then( (response) => {
                
                
                $(".ad-preview-container", $el).css({
                    width: width,
                    height: height,
                    "margin-left": width / -2,
                    "margin-top": height / -2,
                });

                let frame = this.getFrame(width, height, response.data);
                $(".ad-preview-container", $el).append(frame);

                $el.css("top", "1vh");
                $scope.isHidden = false;
            });

    }

    getFrame(width, height, content) {

        let frame = document.createElement("iframe");                            
        frame.src = "about:blank";
        frame.setAttribute("webkitallowfullscreen", true);
        frame.setAttribute("mozallowfullscreen", true);     
        frame.frameBorder = 0;
        frame.scrolling = "no";
        frame.marginWidth = 0;
        frame.marginHeight = 0;
        frame.hspace = 0;
        frame.vspace = 0;
        frame.seamless = true;
        frame.allowTransparency = true;
        frame.allowFullscreen = true;
        frame.style.cssText = "width: " + width + "px; height: " + height + "px; border: 0; margin 0; padding: 0;";
        frame.srcdoc = content;

        return frame;
    }

}

angular.module('cpm')
    .directive('adPreview', ['$rootScope', 'CreativeService', '$compile', '$timeout', ($rootScope, CreativeService, $compile, $timeout) => {
        'use strict';
        return new AdPreview($rootScope, CreativeService, $compile, $timeout);
    }]);
